import * as React from 'react';

import * as styles from './pageHero.module.scss';

export interface PageHeroProps {
  heroContent?: any;
  children?: React.ReactNode;
}

const PageHero = ({heroContent, children}: PageHeroProps) => {
  let heroQuote = null;
  let heroImage = null;
  let heroText = null;

  if (heroContent) {
    heroQuote = heroContent.hero_quote;
    heroImage = heroContent.hero_image ? heroContent.hero_image.url : null;
    heroText = heroContent.hero_text;

    if (heroText) {
      // We need to check the text field since sometimes it appears empty,
      // but in reality it's returning empty <p> tags
      heroText = heroText.text ? heroText.html : null;
    }
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.content}>
        {heroText && (
          <div className={styles.row}>
            {heroQuote && !heroImage && (
              <div className={styles.col}>
                <p className={`${styles.lede} ${styles.quote}`}>
                  {heroQuote.text}
                </p>
              </div>
            )}

            <div className={styles.col}>
              <p>
                <div dangerouslySetInnerHTML={{__html: heroText}} />
              </p>
            </div>

            {heroImage && (
              <div className={styles.col}>
                <img
                  className={styles.image}
                  src={heroImage}
                  alt=""
                  role="presentation"
                />
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default PageHero;
